<template>
  <div class="contactForm">
    <v-card  fill-height class="box mt-2">
                                        <v-card-text>
                                            <v-layout row wrap>
                                                <v-flex xs12>
                                                    <div class="headline mb-3">{{sendEnquiry ? "Enquire Now": "Email Quote"}}</div>
                                                </v-flex>

                                                <v-flex xs12>

                                                    <v-text-field single-line  v-model="value.firstName" dark label="First Name" v-validate="'required'"  data-vv-name="first name" :error-messages="errors.collect('first name')"></v-text-field>
                                                </v-flex>
                                                <v-flex xs12>

                                                    <v-text-field  single-line v-model="value.lastName" dark label="Last Name" v-validate="'required'"  data-vv-name="last name" :error-messages="errors.collect('last name')"></v-text-field>
                                                </v-flex>

                                                <v-flex xs12>
                                                    <v-text-field single-line v-model="value.email" dark label="Email" v-validate="'required|email'"  data-vv-name="email" :error-messages="errors.collect('email')"></v-text-field>
                                                </v-flex>

                                                <v-flex xs12>
                                                    <v-text-field single-line v-model="value.phone" dark label="Phone" v-validate="'min:8'"  data-vv-name="phone" :error-messages="errors.collect('phone')"></v-text-field>
                                                </v-flex>
                                                <v-flex xs12>
                                                    <v-btn block depressed color="primary" @click="send()"> Send</v-btn>
                                                </v-flex>
                                                <v-progress-linear :indeterminate="true" v-if="displayLoader"></v-progress-linear>

                                            </v-layout>

                                        </v-card-text>
                                    </v-card>

                       
  </div>
</template>

<script>
  
export default {
  name: 'ContactForm',
  props: {
      sendEnquiry: Boolean,
      value: Object, //output object contains all the form values. 
      displayLoader: Boolean
  },
  inject: [ 'parentValidator' ],
   created () {
    this.$validator = this.parentValidator
  },
  data() {
    return {
    }
  },
  
  watch: {
      value: {
          handler(val) {
            this.$emit('input',val)
          },
          deep:true
      }
  },
  methods: {
      send(){
          this.$emit('send')

      }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
